import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import env from "@/app/config/env";

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

function loadGtmScript(containerId: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  } as Record<string, unknown>);
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  document.head.appendChild(script);

  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`;
  iframe.setAttribute("height", "0");
  iframe.setAttribute("width", "0");
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";
  document.body.insertBefore(iframe, document.body.firstChild);
}

export function GtmPageView() {
  const location = useLocation();
  const gtmLoaded = useRef(false);

  useEffect(() => {
    const keyGTM = env.keyGTM;
    if (typeof keyGTM !== "string" || gtmLoaded.current) return;
    gtmLoaded.current = true;
    loadGtmScript(keyGTM);
  }, []);

  useEffect(() => {
    if (!env.keyGTM) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtualPageView",
      pagePath: window.location.pathname,
      pageTitle: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
